import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import "../styles/DataList.css";

const DataList = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const dataType = queryParams.get("type") || "all";
  const source = queryParams.get("source") || "default";

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        // 使用 JSONPlaceholder API 作为示例
        const response = await fetch(
          "https://jsonplaceholder.typicode.com/posts"
        );
        if (!response.ok) {
          throw new Error("数据获取失败");
        }
        const jsonData = await response.json();
        setData(jsonData);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading) return <div className="loading">加载中...</div>;
  if (error) return <div className="error">错误: {error}</div>;

  return (
    <div className="page-container">
      <h1>数据列表{dataType}</h1>

      <div className="page-links">
        <Link
          to={{
            pathname: "/products",
            search: "?view=list&filter=all",
          }}
          className="page-link"
        >
          产品管理
        </Link>
        <Link
          to={{
            pathname: "/user",
            search: "?page=data&action=browse",
          }}
          className="page-link"
        >
          用户中心
        </Link>
        <Link
          to={{
            pathname: "/settings",
            search: "?section=data&tab=display",
          }}
          className="page-link"
        >
          系统设置
        </Link>
      </div>

      <div className="data-grid">
        {data.map((item) => (
          <div key={item.id} className="data-card">
            <h3>{item.title}</h3>
            <p>{item.body}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default DataList;
